import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from 'app/store/axios/axiosBaseQuery';

const emptyIdApi = createApi({
  tagTypes: [],
  baseQuery: axiosBaseQuery(),
  endpoints: () => ({}),
});

export default emptyIdApi;
